import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll position to the top on every route change.
 * Rendered once inside the Router so it applies app-wide, fixing the issue
 * where navigating (e.g. from a footer link at the bottom of a page) would
 * land on the new page still scrolled to the bottom.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
